import { Pagination } from 'react-bootstrap'
import React from 'react'

interface Props {
    start: number
    limit: number
    sort: string | null
    hasMore: boolean
    fetchCallback: (start: number, sort: string | null) => void
}

function PaginationBox({ start, limit, sort, hasMore, fetchCallback }: Props) {
    const maxPages = 6
    const currentPage = Math.ceil(start / limit) + 1
    const allPages = [...Array(currentPage).keys()].map(i => {
        if (currentPage > maxPages && i < currentPage - maxPages) return null
        const startNext = i * limit
        const isActive = (i + 1) === currentPage
        return <Pagination.Item active={isActive} key={i + 1} onClick={() => fetchCallback(startNext, sort)}>{i + 1}</Pagination.Item>
    })

    const startNext = start + limit
    const startBefore = limit * (currentPage - maxPages - 1)
    return (
        <div>
            <Pagination size="sm">
                {currentPage > 2 ? <Pagination.First onClick={() => fetchCallback(0, sort)} /> : null}
                {currentPage > maxPages ? <Pagination.Ellipsis onClick={() => fetchCallback(startBefore, sort)} /> : null}
                {allPages}
                {hasMore ? <Pagination.Ellipsis onClick={() => fetchCallback(startNext, sort)} /> : null}
                {hasMore ? <Pagination.Next onClick={() => fetchCallback(startNext, sort)} /> : null}
            </Pagination>
        </div>
    )
}

export default PaginationBox
